import mapAction from './mapAction';

export default mapAction('employee');